import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Transactions from './pages/Transactions';
import Categories from './pages/Categories';
import Login from './pages/Login';
import PrivateRoute from './PrivateRoute';
import Budgets from './pages/Budgets';
import Jars from './pages/Jars';
import Reports from './pages/Reports';
import NothingHere from './pages/NothingHere';

function Routes() {
	return (
		<Switch>
			<Route exact path="/login">
				<Login />
			</Route>
			<PrivateRoute exact path="/categories">
				<Categories />
			</PrivateRoute>
			<PrivateRoute exact path="/budgets">
				<Budgets />
			</PrivateRoute>
			<PrivateRoute exact path="/jars">
				<Jars />
			</PrivateRoute>
			<PrivateRoute exact path="/reports">
				<Reports />
			</PrivateRoute>
			<PrivateRoute exact path="/">
				<Transactions />
			</PrivateRoute>
			<Route component={NothingHere} />
		</Switch>
	);
}

export default Routes;
